import { FC } from 'react';
import { styled } from '@mui/material/styles';

interface CoreTableCellProps extends React.HTMLAttributes<HTMLDivElement> {
	flex?: number;
	heightAuto?: boolean;
	size: number | string;
}

export const CoreTableCell: FC<CoreTableCellProps> = styled('div', {
	shouldForwardProp: (name) => name !== 'flex' && name !== 'size' && name !== 'heightAuto',
})<CoreTableCellProps>(({ theme, flex, size, heightAuto }) => ({
	...theme.typography.label,
	padding: `${!heightAuto ? '4px' : '0'} 6px`,
	display: 'flex',
	alignItems: 'center',
	minWidth: 0,
	width: size ? size : 'auto',
	flex: flex ? `${flex} 1 0` : '0 0 auto',
	textAlign: 'left',
	whiteSpace: 'nowrap',
	height: !heightAuto ? 48 : 'auto',
}));
